export default __webpack_public_path__ + "static/media/EU.064bd08c.svg";